import React from "react";
import { Form } from "react-bootstrap";
import { Labels } from "./PatientLabels";
import { IoIosInformationCircle } from "react-icons/io";
import Select from "react-select";

interface SessionEndReasonProps {
  labels: Labels;
  setLabels: (labels: Labels) => void;
}

const SessionEndReason = ({ labels, setLabels }: SessionEndReasonProps) => {
  //get current value
  const getCurrentValue = () => {
    const existingLabel = labels.find(
      (label) => label.key === "THERAPY_END_REASON",
    );
    return existingLabel ? existingLabel.value : "";
  };

  const handleEndReason = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";

    if (value === "") {
      const updatedLabels = labels.filter(
        (label) => label.key !== "THERAPY_END_REASON",
      );
      setLabels(updatedLabels);
      return;
    }

    const endReason = { key: "THERAPY_END_REASON", value: value };
    const reasonExists = labels.some(
      (label) => label.key === "THERAPY_END_REASON",
    );

    let updatedLabels;
    if (reasonExists) {
      updatedLabels = labels.map((label) =>
        label.key === "THERAPY_END_REASON" ? endReason : label,
      );
    } else {
      updatedLabels = [...labels, endReason];
    }

    setLabels(updatedLabels); // Update the state with the new labels array
  };
  const options = [
    {
      value: "RESUMPTION",
      label: (
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          Wiederaufnahme
          <IoIosInformationCircle title="Wiederaufnahme der Therapie binnen 6 Monaten" />
        </div>
      ),
    },
    {
      value: "REGULAR_ENDING",
      label: (
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          Reguläres Therapieende
          <IoIosInformationCircle title="einvernehmlich, mit ODER ohne Rezidivprophylaxe" />
        </div>
      ),
    },
    {
      value: "EARLY_TERMINATION_BY_MUTUAL_AGREEMENT",
      label: (
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          Vorzeitiges Therapieende(im Einverständnis)
          <IoIosInformationCircle title="Stundenkontingent gemäß der PT-RL erschöpft ODER Verlängerung von KK abgelehnt" />
        </div>
      ),
    },
    {
      value: "TERMINATION_BY_PATIENT",
      label: (
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          Therapieabbruch durch Patient*in
          <IoIosInformationCircle title="Therapieabbruch durch Patienten" />
        </div>
      ),
    },
    {
      value: "TERMINATION_BY_THERAPIST",
      label: (
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          Therapieabbruch durch Therapeut*in
          <IoIosInformationCircle title="Therapieabbruch durch Therapeuten" />
        </div>
      ),
    },
    {
      value: "OTHER",
      label: (
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          Sonstiger Grund
        </div>
      ),
    },
  ];

  return (
    <Form.Group>
      <Form.Label>Beendigungsgrund</Form.Label>
      <Select
        options={options}
        value={options.find((o) => o.value === getCurrentValue()) || null}
        onChange={handleEndReason}
        placeholder="Auswählen..."
        aria-label="Auswählen"
      />
    </Form.Group>
  );
};

export default SessionEndReason;
